import { cx } from '@/lib/utils/cx';

/**
 * The Meta brand mark lives in exactly one place: `public/svg/meta.svg`.
 *
 * Rendered as an `<img>` rather than inline SVG, for the same reason as
 * `gmail`: the artwork carries global gradient ids that would collide across
 * copies if inlined. `object-contain` preserves its wide aspect ratio inside
 * the square sizing classes callers pass.
 *
 * `alt=""` (decorative): call sites render the mark inside a labelled group.
 *
 * Typed for the element it actually renders, unlike `gmail`: that one keeps an
 * `SVGProps` signature so it stays assignable to the provider-icon registries
 * beside the real inline-SVG marks. Meta belongs to no such registry, so the
 * honest type is the better one.
 */
const META_ICON_SRC = '/svg/meta.svg';

const Meta = ({ className }: Readonly<{ className?: string }>) => (
  <img alt="" className={cx('object-contain', className)} src={META_ICON_SRC} />
);

export { Meta };
